import React from "react";

import CheckMark from "./../CheckMark/CheckMark";
import style from "./style.module.css";

function index({ text, checked, setChecked, value }) {
  const handleElementClick = () => {
    setChecked((prevArray) =>
      !prevArray.includes(value)
        ? [...prevArray, value]
        : prevArray.filter((item) => item !== value)
    );
  };
  return (
    <div
      data-tracking="click"
      data-value=""
      className={style.checkboxContainer}
      onClick={() => {
        handleElementClick();
      }}
    >
      {checked ? (
        <div className={`${style.checked}`}>
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect width="20" height="20" rx="4" fill="#4609F0" />
            <path
              d="M5.3335 10.6666L8.00016 13.3333L14.6668 6.66663"
              stroke="white"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
      ) : (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5.33398 10.6666L8.00065 13.3333L14.6673 6.66663"
            stroke="#EDE6FE"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            className={style.check}
          />
          <rect
            x="0.5"
            y="0.5"
            width="19"
            height="19"
            rx="3.5"
            stroke="#BFC4C6"
          />
        </svg>
      )}
      <span>{text}</span>
    </div>
  );
}

export default index;
